import { useRouter } from 'next/router'
import React from 'react'
import { styled } from '@mui/material'

import { Button } from '@/components/Button/Button'
import { pxToRem } from '@/shared/styles/themes'

export type NavItemProps = React.ComponentProps<typeof StyledMuiLink> & {
  href?: string
  children: React.ReactNode
}

export const NavItem: React.FC<NavItemProps> = ({ href, children, ...props }) => {
  const router = useRouter()

  const onNavLinkClick: React.MouseEventHandler<HTMLButtonElement> = (ev) => {
    if (href) {
      router.push(href)
    }

    if (props.onClick) {
      props.onClick(ev)
    }
  }

  return (
    <StyledMuiLink primary size={'large'} onClick={onNavLinkClick} {...props}>
      {children}
    </StyledMuiLink>
  )
}

export const StyledMuiLink = styled(Button)`
  margin-right: ${(props) => props.theme.typography.pxToRem(-16)};
  font-weight: 500;
  padding:  ${(props) => props.theme.spacing(2.5, 4)};

  ${props => props.theme.breakpoints.up('sm')} {
   padding: ${pxToRem(12)} ${pxToRem(16)};
  }
`